var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FA4616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21C17.866 21 21 17.866 21 14C20.9959 10.1357 17.8643 7.00413 14 7ZM16.948 14.223C16.8995 14.3203 16.8207 14.3991 16.7235 14.4475V14.45L12.7235 16.45C12.4765 16.5734 12.1762 16.4733 12.0527 16.2262C12.0176 16.156 11.9996 16.0785 12 16V12C11.9999 11.7239 12.2236 11.4999 12.4998 11.4998C12.5774 11.4997 12.654 11.5178 12.7235 11.5525L16.7235 13.5525C16.9706 13.6757 17.0712 13.9759 16.948 14.223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.59c2155f3089aed69082224d9d6b2f0b.svg";
export { ForwardRef as ReactComponent };